export default {
  "b2b.prehled": "prehled",

  "b2b.provozni-informace.list": "provozni-informace",
  "b2b.provozni-informace.detail": "provozni-informace/:id/detail",
  "b2b.provozni-informace.new": "provozni-informace/nova",
  "b2b.provozni-informace.edit": "provozni-informace/:id/editace",

  "b2b.rezervace": "rezervace",
  "b2b.rezervace.historie": "rezervace/historie",
  "b2b.rezervace.odbaveni": "rezervace/odbaveni",
  "b2b.rezervace.vytvoreni": "rezervace/nova",
  "b2b.rezervace.casovy-plan": "rezervace/casovy-plan",

  "b2b.administrace": "administrace",
  "b2b.administrace.konfiguracni-parametry":
    "administrace/konfiguracni-parametry",
  "b2b.administrace.zakaznik": "administrace/zakaznik/:ico",
  "b2b.administrace.zakaznik.smluva": "administrace/zakaznik/:ico/smlouva/:id?",
  "b2b.administrace.zakaznik.projekt":
    "administrace/zakaznik/:ico/projekt/:id?",
  "b2b.administrace.zakaznici": "administrace/zakaznici",
  "b2b.administrace.zdroje": "administrace/zdroje",
  "b2b.administrace.zdroj": "administrace/zdroj/:id?",
  "b2b.administrace.produkt": "administrace/produkt/:id?",
  "b2b.administrace.doplnkova-sluzba": "administrace/doplnkova-sluzba/:id?",

  "b2b.zadosti.detail": "zadost/:id",

  "b2b.unauthorized": "nedostatecna-opravneni"
};
